
import { defineComponent, toRefs } from 'vue';
import { useVModel } from 'vue-composable';
import { useGapi } from '@/services';
import { InputElementTypes } from '@/enums';
import TextInputStyleProvider from '@/components/style-providers/TextInputStyleProvider.vue';
import BaseInput from '@/components/form-controls/base/BaseInput.vue';
import MaterialIconButton from './MaterialIconButton.vue';

export default defineComponent({
  name: 'GoogleDriverPicker',
  components: {
    TextInputStyleProvider,
    BaseInput,
    MaterialIconButton
  },
  emits: ['update:modelValue'],
  props: {
    label: {
      type: String
    },
    modelValue: {
      type: String
    },
    view: {
      type: String,
      validator: (value: string) => (Object.values(google.picker.ViewId) as string[]).includes(value)
    }
  },
  setup(props, { emit }) {
    const { initPicker } = useGapi();
    const state = useVModel(props, 'modelValue');
    const setState = (id: string) => {
      emit('update:modelValue', id);
    };

    const showPicker = initPicker(props.view as google.picker.ViewId);

    return {
      ...toRefs(props),
      state,
      InputElementTypes,
      showPicker: () => showPicker(setState)
    };
  }
});
